// extracted by mini-css-extract-plugin
module.exports = {"description":"_12qR97s8PdIn3qg4oTUgVK","pageHeader":"_2wljW5YHsfA8o7WOZyOJDD","icon":"qiuydds3vg-gjE_6N2CTU","container":"_2AaoKEgmqImNkfb5AR-50y"};